import React, { Fragment } from 'react';
import numeral from 'numeral';

import {
    Typography,
    Box,
    Grid,
    colors,
    makeStyles,
    Chip,
    Avatar
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {

    },
    labelvalue: {
        padding: 5
    },
    instrumenticon: {
        padding: 2,
        width: 50,
        height: 50
    },
    chipgreen: {
        backgroundColor: colors.green[400],
        width: 100,
        margin: 1
    },
    chipblue: {
        backgroundColor: colors.blue[400],
        width: 100,
        margin: 1
    },
    chipred: {
        backgroundColor: colors.red[600],
        width: 100,
        margin: 1,
        color: "#ffffff"
    }

}));


const INST01 = ({ instrument, message, event, instruments, alarm, device, schedules, commands, sendCommands }) => {

    const classes = useStyles();

    const isAlarmedField = (field, alarm) => {
        if (alarm === undefined || field === undefined) {
            return false;
        }
        if (Object.keys(alarm).length != 0) {
            var count = 0;
            alarm.fails.map((fail) => {
                if (fail.field.id == field._id && fail.type === 'fail') {
                    count++;
                }
            })
            return (count > 0);
        }
        return false
    }

    return (
        <Fragment>
            <Box padding={1} margin={instrument.border} border={instrument.border} borderRadius={instrument.radius}
                borderColor={colors.grey[300]}  >
                <Typography color="textSecondary" variant="h5" >
                    <b>{instrument.label}</b>
                </Typography>

                <Grid
                    container
                    direction="row"
                    justify="space-evenly"
                    alignItems="center"
                >

                    <Grid item xs="auto">

                        {instrument.inputfields.map((infield, index) => (
                            message.inputs.map((field, index) => (
                                (field.order === infield.fieldindex) ? (
                                    <Grid
                                        container
                                        direction="row"
                                        justify="flex-start"
                                        alignItems="center"
                                    >
                                        <Grid item xs="auto">
                                            <Typography color="secondary" variant="body2" className={classes.labelvalue}  >
                                                {infield.label}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="auto">

                                            {isAlarmedField(field, alarm) ? (
                                                <Chip className={classes.chipred}
                                                    size="small"
                                                    label={numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix} />

                                            ) : (
                                                <Chip className={classes.chipgreen}
                                                    size="small"
                                                    label={numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix} />

                                            )}

                                        </Grid>
                                    </Grid>
                                ) : (<div></div>)
                            ))
                        ))}

                        {instrument.outputfields.map((infield, index) => (
                            message.inputs.map((field) => (
                                (field.order === infield.fieldindex && (index >= instrument.inputfields.length)) ? (
                                    <Grid item xs="auto">
                                        <div>&nbsp;</div>
                                    </Grid>
                                ) : (<div></div>)
                            ))
                        ))}

                    </Grid>

                    <Grid item xs="auto">
                        <Avatar className={classes.instrumenticon} variant="square"
                            src={`/static/images/instruments/` + instrument.simbol}>
                        </Avatar>
                    </Grid>

                    <Grid item xs="auto">
                        {instrument.outputfields.map((infield, index) => (
                            message.inputs.map((field, index) => (
                                (field.order === infield.fieldindex) ? (

                                    <Grid
                                        container
                                        direction="row"
                                        justify="flex-start"
                                        alignItems="center"
                                    >
                                        <Grid item xs="auto">

                                            {isAlarmedField(field, alarm) ? (
                                                <Chip className={classes.chipred}
                                                    size="small"
                                                    label={numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix} />

                                            ) : (
                                                <Chip className={classes.chipgreen}
                                                    size="small"
                                                    label={numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix} />

                                            )}

                                        </Grid>

                                        <Grid item xs="auto">
                                            <Typography color="secondary" variant="body2" className={classes.labelvalue}>
                                                {infield.label}
                                            </Typography>
                                        </Grid>

                                    </Grid>

                                ) : (<div></div>)
                            ))
                        ))}

                        {instrument.inputfields.map((infield, index) => (
                            message.inputs.map((field) => (
                                (field.order === infield.fieldindex && (index >= instrument.outputfields.length)) ? (
                                    (
                                        <Grid item xs="auto">
                                            <div>&nbsp;</div>
                                        </Grid>
                                    )
                                ) : (<div></div>)
                            ))
                        ))}
                    </Grid>
                </Grid>

            </Box>
        </Fragment >
    );

}

export default INST01;